/**
 * Display config for visio backgrounds.
 */
import { CheckCircle2, XCircle, type LucideIcon } from 'lucide-react';
import type { BadgeVariant } from '@/components/common/LabelBadge';

/** Label, icon, and badge variant for Actif / Désactivé. */
export interface VisioBackgroundToggleConfig {
  label: string;
  icon: LucideIcon;
  badgeVariant: BadgeVariant;
  badgeColor?: string;
}

/** Same icons as the other Actif / Inactif {@link LabelBadge} configs (`CheckCircle2` / `XCircle`). */
export const VISIO_BACKGROUND_TOGGLE_CONFIG: Record<
  'active' | 'inactive',
  VisioBackgroundToggleConfig
> = {
  active: { label: 'Actif', icon: CheckCircle2, badgeVariant: 'active' },
  inactive: {
    label: 'Désactivé',
    icon: XCircle,
    badgeVariant: 'outlined',
    badgeColor: 'rgb(var(--color-error))',
  },
};

/** React Query key for `GET /visio-backgrounds/:id`. */
export const VISIO_BACKGROUND_FORM_QUERY_KEYS = {
  one: (id: string) => ['visio-background', id] as const,
};

/** Max backgrounds a company can keep. */
export const MAX_VISIO_BACKGROUNDS = 20;

/** MIME types plus extensions so the file dialog opens on JPEG, PNG, and WEBP. */
export const VISIO_BACKGROUND_ACCEPTED_FORMATS =
  'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp';

/** Max upload size for a visio background (5 MB). */
export const VISIO_BACKGROUND_MAX_SIZE_BYTES = 5 * 1024 * 1024;
